import { useAuth } from "@clerk/clerk-react";
import { useQuery } from "@tanstack/react-query";
import type { AssetType } from "../generated/api/types.gen";
import { assetsQuery } from "../lib/queries";

/** Assets visible to the current user; omit `type` for all asset types. */
export function useAssets(enabled: boolean, type?: AssetType) {
  const { orgId } = useAuth();
  const query = useQuery({
    ...assetsQuery(orgId, type),
    enabled,
  });
  const isFetching = query.isFetching;
  return {
    assets: query.data ?? [],
    isLoading: isFetching && query.data === undefined,
    isError: query.isError && !isFetching,
    refetch: query.refetch,
  };
}
